module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Benito’s Truth")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#foreword-benitos-treasure-fact-or-fiction"
    }
  }, [_vm._v("Foreword: Benito’s Treasure – Fact or Fiction?")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-love-and-war"
    }
  }, [_vm._v("Chapter 1: Love and War")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-a-nuns-tale"
    }
  }, [_vm._v("Chapter 2: A Nun’s Tale")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#chapter-3-the-pirate-code"
    }
  }, [_vm._v("Chapter 3: The Pirate Code")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-the-captain-who-never-was",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: The Captain Who Never Was")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-benitos-treasure",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Benito’s Treasure")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-sydney-town",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Sydney Town")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-kerosine-jack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Kerosine Jack")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-welcome-to-the-rocks",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: Welcome to the Rocks")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-the-rivals",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: The Rivals")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-henrys-hammer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Henry’s Hammer")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-farewell-to-a-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Farewell to a Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-river-run",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: River Run")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-down-to-the-sea-in-ships",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Down to the Sea in Ships")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-pleasure-and-pain",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Pleasure and Pain")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-the-price-of-freedom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Price of Freedom")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-the-prison-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The Prison Years")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-green-fire",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Green Fire")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-the-prodigal-son",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: The Prodigal Son")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-never-trust-the-government",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Never Trust the Government")])]), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-annie",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Annie")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-21-when-yknow-yknow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: When Y’know, Y’know")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-22-blast-from-the-past",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Blast from the Past")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-23-merrie-england",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Merrie England")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-24-the-black-dog",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: The Black Dog")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-25-the-hand-of-god",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: The Hand of God")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-26-where-the-cross-meets-the-cross",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Where the Cross Meets the Cross")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0